/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default function createColorRamp(
  key: string, // The key of the color in the color object
  name: string, // The output key name
  colors: {} // The palette of colors
): {
  [string]: any
} {
  const ramp = {};

  for (let index = 10; index <= 100; index += 10) {
    ramp[`color_${name}_${index}`] = colors[`${key}_${index}`];
  }

  return ramp;
}



// WEBPACK FOOTER //
// ./src/themes/createColorRamp.js